import r from "../../temp-lib/config/index.js";
import { EventFooter as i } from "../../temp-lib/constants/gtm.js";
import e from "../assets/icon-community-apeiron-discord.png.js";
import a from "../assets/icon-community-apeiron-mavis-market.png.js";
import E from "../assets/icon-community-apeiron-substack.png.js";
import c from "../assets/icon-community-apeiron-youtube.png.js";
import I from "../assets/icon-community-doodi-facebook-light.png.js";
import N from "../assets/icon-community-doodi-instagram-light.png.js";
import L from "../assets/icon-community-doodi-kwai-light.png.js";
import m from "../assets/icon-community-doodi-mevx.png.js";
import T from "../assets/icon-community-doodi-pancake-swap.png.js";
import O from "../assets/icon-community-doodi-telegram.png.js";
import _ from "../assets/icon-community-doodi-xiaohongshu-light.png.js";
import M from "../assets/icon-community-doodi-youtube-light.png.js";
import A from "../assets/icon-community-share-email.png.js";
import n from "../assets/icon-community-share-x.png.js";
var R = /* @__PURE__ */ ((o) => (o.DoodipalX = "DoodipalX", o.FacebookLight = "Facebook_L", o.InstagramLight = "Instagram_L", o.KwaiLight = "Kwai_L", o.MEVX = "MEVX", o.PancakeSwap = "PancakeSwap", o.Telegram = "Telegram", o.XiaohongshuLight = "Xiaohongshu_L", o.YoutubeLight = "Youtube_L", o))(R || {});
const l = {
  DoodipalX: {
    icon: n,
    href: r.EXTERNAL_URL.COMMUNITY.DOODI_COIN_X,
    event: i.ToDoodiCoinX
  },
  Facebook_L: {
    icon: I,
    href: r.EXTERNAL_URL.COMMUNITY.DOODI_FACEBOOK,
    event: i.ToDoodiFacebook
  },
  Instagram_L: {
    icon: N,
    href: r.EXTERNAL_URL.COMMUNITY.DOODI_INSTAGRAM,
    event: i.ToDoodiInstagram
  },
  Kwai_L: {
    icon: L,
    href: r.EXTERNAL_URL.COMMUNITY.DOODI_KWAI,
    event: i.ToDoodiKwai
  },
  MEVX: {
    icon: m,
    href: r.EXTERNAL_URL.COMMUNITY.DOODI_MEVX,
    event: i.ToDoodiMEVX
  },
  PancakeSwap: {
    icon: T,
    href: r.EXTERNAL_URL.COMMUNITY.DOODI_PANCAKE_SWAP,
    event: i.ToDoodiPancakeSwap
  },
  Telegram: {
    icon: O,
    href: r.EXTERNAL_URL.COMMUNITY.DOODI_TELEGRAM,
    event: i.ToDoodiTelegram
  },
  Xiaohongshu_L: {
    icon: _,
    href: r.EXTERNAL_URL.COMMUNITY.DOODI_XIAO_HONG_SHU,
    event: i.ToDoodiXiaohongshu
  },
  Youtube_L: {
    icon: M,
    href: r.EXTERNAL_URL.COMMUNITY.DOODI_YOUTUBE,
    event: i.ToDoodiYoutube
  }
};
var D = /* @__PURE__ */ ((o) => (o.Discord = "Discord", o.Email = "Email", o.MavisMarket = "MavisMarket", o.Substack = "Substack", o.X = "X", o.YouTube = "YouTube", o))(D || {});
const t = {
  Discord: {
    icon: e,
    href: r.EXTERNAL_URL.COMMUNITY.APEIRON_DISCORD,
    event: i.ToApeironDiscord
  },
  X: {
    icon: n,
    href: r.EXTERNAL_URL.COMMUNITY.APEIRON_X,
    event: i.ToApeironX
  },
  Substack: {
    icon: E,
    href: r.EXTERNAL_URL.COMMUNITY.APEIRON_SUBSTACK,
    event: i.ToApeironSubstack
  },
  YouTube: {
    icon: c,
    href: r.EXTERNAL_URL.COMMUNITY.APEIRON_YOUTUBE,
    event: i.ToApeironYoutube
  },
  MavisMarket: {
    icon: a,
    href: r.EXTERNAL_URL.COMMUNITY.APEIRON_MAVIS_MARKET_PLANET,
    event: i.ToApeironSkyMavis
  },
  Email: {
    icon: A,
    href: `mailto:${r.EXTERNAL_URL.COMMUNITY.SHARE_EMAIL}?subject=Eniqury from Apeiron`,
    event: i.ToEmail
  }
}, w = [
  t.Discord,
  t.X,
  t.Substack,
  t.YouTube,
  t.MavisMarket,
  t.Email
];
export {
  t as ApeironMediaMap,
  D as ApeironMediaType,
  w as DefaultLinks,
  l as DoodiMediaMap,
  R as DoodiMediaType
};
//# sourceMappingURL=media.js.map
